import type { SavedASTType } from 'src/api/generated/touring/types';
import type { AstFavoriteType } from '../../types';

export const mapASTFavoriteType = (favorite: SavedASTType): AstFavoriteType => ({
  id: favorite.id,
  name: favorite.name,
  ast: favorite.ast as AstFavoriteType['ast'],
});
